export const MODERATION_PATH = "/moderation"
export const MODERATION_REPORTS_PATH = "/moderation/reports"

export const buildReportPath = (reportId: number | string): string => `${MODERATION_REPORTS_PATH}/${reportId}`
